<template>
	<section>
		<div>
			<Header></Header>
			<div class="m-doc">
				<p>欧朋浏览器</p>
				<p>挖掘<span style="color: rgba(211, 77, 58, 1);">有趣的</span>价值</p>
				<p @click="donwload">下载手机浏览器</p>
			</div>
            <div class="m-images">
                <img src="../../../static/images/13@3x.png" alt="">
            </div>
		</div>
        <div class="index-left-radius">
			<img src="../../../static/images/left-radius.png" alt="">
		</div>
        <div class="bg2">
            <div class="banner-text">
                <p class="title"><span style="color: rgba(211, 77, 58, 1);">简洁</span>设计</p>
                <img class="mark" src="../../../static/images/mark@3x.png" alt="">
                <p class="doc">秉承极简的设计思路，巧妙进行UI布局，增加最近关闭的标签历史，贴心实现一键关闭所有页面，让你轻松从容地上网浏览。</p>
            </div>
            <div class="banner-image">
                <img src="../../../static/images/12@3x.png" alt="">
            </div>
        </div>
        <div class="index-right-radius">
			<img src="../../../static/images/right-radius.png" alt="">
		</div>
        <div class="bg2">
            <div class="banner-text">
                <p class="title">安全<span style="color: rgba(211, 77, 58, 1);">无痕</span></p>
                <img class="mark" src="../../../static/images/mark@3x.png" alt="">
                <p class="doc">在无痕浏览过程中，不会保存任何浏览历史、搜索历史、下载历史、表单历史、cookie 或者 Internet临时文件，保护您的个人隐私。</p>
            </div>
            <div class="banner-image">
                <img src="../../../static/images/10@3x.png" alt="">
            </div>
        </div>
        <div class="index-left-radius-1">
            <img src="../../../static/images/left-boder.png" alt="">
        </div>
        <div class="bg2">
            <div class="banner-text">
                <p class="title"><span style="color: rgba(211, 77, 58, 1);">护眼</span>模式</p>
                <img class="mark" src="../../../static/images/mark@3x.png" alt="">
                <p class="doc">启用护眼模式时，会自动调节屏幕背景、文字和图标颜色，增加对比度，调整色温，使得用户浏览网页时，减少了眼睛的疲劳感，更加舒适。</p>
            </div>
            <div class="banner-image">
                <img src="../../../static/images/11@3x.png" alt="">
            </div>
        </div>
        <div class="index-right-radius-2">
            <img src="../../../static/images/right-border.png" alt="">
        </div>
		<Footer></Footer>
	</section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'Mobile',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
    methods: {
        donwload() {
            window.open("https://dl.oupeng.com/tor/m/oupengtor-12.101.0.1.apk");
        }
    },
	computed: {}
}
</script>

<style scoped>
img {
    width: 140%;
    height: 100%;
}
.m-images {
    position: relative;
    top: -0.3rem;
    right: 0.7rem;
    /* overflow: hidden; */
}
.m-doc {
    position: relative;
	width: 2rem;
    z-index: 99;
	margin-left: 0.15rem;
}
.m-doc p:nth-child(1) {
	font-size: 0.28rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
}
.m-doc p:nth-child(2) {
	font-size: 0.14rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
	padding: 0.1rem 0 0 0;
}
.m-doc p:nth-child(3) {
	width: 1.2rem;
	height: 0.4rem;
	opacity: 1;
	font-size: 0.12rem;
	color: #fff;
	line-height: 0.4rem;
	text-align: center;
	border-radius: 30px;
	margin: 0.15rem 0 0 0;
	background: rgba(247, 67, 68, 1);
    z-index: 99999;
}


.index-left-radius  {
    position: absolute;
    width: 1rem;
    left: 0;
    z-index: -1;
    top: 6rem;
}
.index-right-radius {
	position: absolute;
    width: 1rem;
    right: 0;
    z-index: -1;
    top: 12rem;
}
.index-left-radius-1 {
	position: absolute;
	width: 0.7rem;
	left: 0;
	top: 17.7rem;
	z-index: -1;
}
.index-right-radius-2 {
	position: absolute;
	width: 1rem;
	right: 0;
	top: 23.5rem;
	z-index: -1;
}
.index-left-radius img, .index-right-radius img, .index-left-radius-1 img , .index-right-radius-2 img{
	width: 100%;
	height: 100%;
}

.bg2 {
	width: 100%;
    margin-top: 1rem;
}

.bg2 .left-boder {
	position: absolute;
	bottom: -300px;
	left: 0;
	width: 338px;
	height: 338px;
}

.bg2s .left-boder img {
	display: block;
}

.bg2 .right-radius {
	position: absolute;
	bottom: -200px;
	right: -150px;
	width: 338px;
	height: 338px;
}

.bg2 .right-radius img {
	display: block;
}

.bg2 .banner-image {
	width: 100%;
}

.bg2 .banner-image img {
	display: block;
    width: 3rem;
    margin: 0 auto;
}

.bg2 .banner-text {
	width: 100%;
	margin: 0 auto;
	position: relative;
}

.bg2 .banner-text .title {
	width: 1.3rem;
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.3rem;
    font-weight: 400;
    margin-left: 0.6rem;
}

.bg2 .banner-text .doc {
	width: 2.7rem;
    margin: 0 0 0.5rem 0.6rem;
    font-size: 0.12rem;
    font-weight: 400;
    letter-spacing: 4px;
    line-height: 20px;
    color: rgba(0, 0, 0, 1);
}

.bg2 .banner-text .mark {
    width: 0.6rem;
    height: 0.4rem;
    position: absolute;
    top: -0.1rem;
    right: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Mobile.vue